module.exports = __webpack_public_path__ + "static/img/dy1-11.703b2b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-11.png
// module id = 952
// module chunks = 0